var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vc-donut',{attrs:{"background":"rgba(255, 255, 255, 0.8)","foreground":"transparent","size":_vm.size,"unit":"px","has-legend":false,"thickness":40,"sections":_vm.sections,"total":100,"start-angle":0,"auto-adjust-text-size":false}},[_c('span',{staticStyle:{"margin":"0","font-size":"1.0rem"}},[_vm._v(_vm._s(_vm.count))])])
}
var staticRenderFns = []

export { render, staticRenderFns }